var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"info-container"},[_vm._t("title"),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }